import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { FaSave } from 'react-icons/fa'
import { YesNoRendererComponent } from './yes-no-renderer.component'
import { currency } from '../services/common.service'
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';
import { ExpandTableContainer } from '../expand-table/containers/expand-table.container'
import { LibraryRendererComponent } from './library-renderer.component'
import storePersist from '../../redux/storePersist'
import { useNavigate } from 'react-router-dom'
import { format } from '../services/date.service'
import { useAppDispatch } from '../../hooks/hooks'
import { FiRefreshCw } from "react-icons/fi";
import { InputContainer } from './form/input/containers/input.container'
import { CopyRendererComponent } from './copy-renderer.component'
import { ViewRendererComponent } from './view-renderer.component'
import PaginationContainer from '../pagination/container/pagination.container'
import { useConfirm } from '../../hooks/useConfirm'
import { Menu } from '@headlessui/react'
import { useSelector } from 'react-redux'
import { selectCurrent } from '../../redux/settings/selectors'
import { FilterDrawerComponent } from './filter-drawer'
import { PublishVendorToCloudContextMenus } from './table-manager/context-menus'

const Table = ({ handleParticularOrgRegistry, IsPublishParticularVendorToCloud, onAgentAssignClick, onCargoDriverStatusClick,handleRunScheduledTask, onCargoDeliveryStatusClick, onCargoTransitStatusClick, onCargoIssueStatusClick, onCargoPickupStatusClick, onCargoOrderStatusClick, setPageSize, isEdocs, subColumnDefs, onOrderStatusClick, onPaymentStatusClick, onFullfillmentStatusClick, onReturnRequestStatusClick,
	onSearch = () => { }, enableFilter = false, handleCDNDelete, handleCDNReset, handleCDNUpdateWebsite, columnData, rowData, onEdit, additionButtons, onDelete, headingName, paginationData, setPageData, onShippingStatusClick, handleInputChange,
	searchCriteriaList, filterTypeLists, handlePublishTenantWebsite, IsWebsites, handleUpdateTenantWebsite, handlereset, handleEnableTenantWebsite, IsRowUpdated, handleSave }: any) => {
	const navigate = useNavigate()
	const [anchorShipmentEl, setAnchorShipmentEl] = useState(null);
	const [isExpand, setIsExpand] = useState(false);
	const [subRowData, setSubRowdata] = useState<any>();
	const [subRowDataId, setSubRowdataId] = useState<any>();
	const [showFilter, setShowFilter] = useState(false);
	const [selectedField, setSelectedField] = useState([]);
	const [filteredData, setFilteredData] = useState<any>(rowData);
	const [filterType, setFilterType] = useState([])
	const dispatch = useAppDispatch()
	const companyName = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.CompanyName;
	const { confirm, modal } = useConfirm();
	const result = useSelector(selectCurrent)
	const { sidebar, theme } = result

	const handleClickDelete = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to delete this item?');
		if (isConfirmed) {
			handleDelete(data)
		}
	};
	const handleCDNDeleteClick = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to Delete this  entries in CDN?');
		if (isConfirmed) {
			handleCDNDelete(data)
		}
	};
	const handleClickReset = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to Reset?');
		if (isConfirmed) {
			handlereset(data)
		}
	};

	const handleCDNResetClick = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to Reset this  entries in CDN?');
		if (isConfirmed) {
			handleCDNReset(data)
		}
	};


	const handleSubRowData = (data: any) => {
		setIsExpand(!isExpand)
		if (data?.AssociatedDomains) {
			setSubRowdataId(data?.Id)
			setSubRowdata(data?.AssociatedDomains)
		}

	}
	const filteredFields = _.filter(
		columnData,
		(item) => item.field !== 'Sl' && item.field !== 'Edit'
	)
	const [isCheckAll, setIsCheckAll] = useState(false)


	const handleEdit = (item: any) => {
		onEdit(item)
	}

	const handleDelete = (item: any) => {
		onDelete(item)
	}

	const handleCheckbox = (id: any) => {

	}

	const handleSelectAll = (e: any) => {

	}
	const { PageNumber, PageSize } = paginationData || { PageNumber: 1, PageSize: 10 };
	const startIndex = (PageNumber - 1) * PageSize + 1;

	useEffect(() => {
		console.log(selectedField)
		const newdata: any = [...filterType, "string"]
		setFilterType(newdata)

	}, [selectedField])

	useEffect(() => {
		setFilteredData(rowData)
	}, [rowData]);

	return (

		<>
			<div className={`p-4  w-auto ${sidebar ? `max-w-[calc(100vw-16.5rem)]` : `max-w-[calc(100vw-6.5rem)]`} `}>
				<div className="flex my-2  w-full justify-between items-center px-2">
					<div className="uppercase text-xl">
						{headingName ? headingName : ''}
					</div>
					<div className="flex flex-row">
						{/* <div className=" flex flex-row items-center justify-center text-gray-600">
							<input type="search" name="serch" placeholder="Search products..." className="bg-white h-10 w-48 px-5 rounded border text-sm focus:outline-none" />
							<button type="submit" className="relative right-8 top-0 mr-4">
								<svg className="h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 56.966 56.966"
									width="512px" height="512px">
									<path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
								</svg>
							</button>
						</div> */}
						<div className=' flex flex-row items-end justify-end text-end '>

							{/* Add button */}

							{additionButtons?.length && additionButtons.map((button: any) => (
								<button
									onClick={(event) => button.callback(event)}
									type="button"
									className="group flex items-center mr-2 bg-primary text-white rounded font-medium px-4 py-2 "
									title={button.name}
								>
									<span className=''>{button.svg}</span>
									<span className=''>{button.name}</span>
								</button>
							))}
							{/* Filter button */}
							{enableFilter && <button
								onClick={() => setShowFilter(!showFilter)}
								type="button"
								className="group flex items-center bg-primary text-white rounded font-medium px-4 py-2 "
							>
								<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
									<title>Search and Filters</title>
									<path d="M2.73224 5.32873C1.58574 4.03892 2.50136 2 4.22706 2H19.7734C21.4991 2 22.4147 4.03893 21.2682 5.32873L15.0002 12.3802V21C15.0002 21.3466 14.8208 21.6684 14.5259 21.8507C14.2311 22.0329 13.863 22.0494 13.553 21.8944L9.553 19.8944C9.21421 19.725 9.00021 19.3788 9.00021 19V12.3802L2.73224 5.32873ZM19.7734 4H4.22706L10.7476 11.3356C10.9103 11.5187 11.0002 11.7551 11.0002 12V18.382L13.0002 19.382V12C13.0002 11.7551 13.0901 11.5187 13.2528 11.3356L19.7734 4Z" stroke="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</button>}

						</div>

						{/* Filter Component */}
						{enableFilter && <FilterDrawerComponent
							columnData={columnData}
							rowData={rowData}
							filterTypeLists={filterTypeLists}
							searchCriteriaList={searchCriteriaList}
							setFilteredData={setFilteredData}
							initiateSearch={onSearch}
							showFilter={showFilter}
							setShowFilter={setShowFilter}
						/>}

					</div>
				</div>


				<div className={`overflow-auto  max-h-96 w-full`}>
					{filteredData?.length !== 0 ? <table className="min-w-full text-xs bg-red-50">
						<thead className="leading-normal  sticky top-0 z-10">
							<tr key={'table'} className="bg-red-100 h-12 leading-normal">
								<th key={0}
									className="py-3 px-6 text-left ">
									<input
										checked={isCheckAll}
										type="checkbox"
										name="selectAll"
										id="selectAll"
										onChange={(e: any) => handleSelectAll(e)} />
								</th>
								<th key={1} className='py-3 px-6 text-left border-r border-gray-100'>
									#
								</th>
								{columnData[0]?.isSortLabel ?
									filteredFields.map((column: any, index: any) => (
										<th key={index}
											className=" py-3 px-6 truncate text-left border-r border-gray-100 ">{column.headerName}</th>

									))
									:
									filteredFields.map((column: any, index: any) => (
										<th key={index}
											className="py-3 px-6 truncate text-left border border-gray-100">
											{column.headerName}
										</th>

									))}
								{onEdit || onDelete || IsRowUpdated ? <th
									className="py-3 px-6 text-left">
									Action
								</th> : null}
							</tr>
						</thead>
						<tbody className="bg-red-400 text-sm font-light max-h-24 overflow-y-auto">
							<>
								{filteredData && filteredData?.map((row: any, index: any) => (
									<><tr key={`${row}-${index}`}
										className=" cursor-pointer  even:bg-[#F8F9FAFF] odd:bg-white">
										<td key={0}>
											<span className="py-3 px-6 text-left">
												<input
													type="checkbox"
													defaultChecked={false}
													onChange={(e) => handleCheckbox(e)}
													checked={false} />
											</span>
										</td>
										<td key={1} className='py-3 px-6 text-left border-r border-gray-100'>
											{startIndex + index}
										</td>
										{filteredFields.map((column) => {
											const dataValue: any = _.property(column.field)(row)
											const address = `${dataValue?.address?.building} , ${dataValue?.address?.locality} , ${dataValue?.address?.city} , ${dataValue?.address?.country} , ${dataValue?.address?.state} - ${dataValue?.address?.area_code}`;
											return (

												<>
													<td key={index} className="py-3 px-6 border-r border-gray-100 text-left">
														{!column.input &&
															column.cellRenderer !== 'resetIconRenderer' && column.isCurrencyValueFormat !== true && column.isAddressFormat !== true && column.isDateValueFormat !== true && column.cellRenderer !== 'yesNoRenderer' && column.cellRenderer !== 'libraryRendererComponent' && column.cellRenderer !== 'copyRenderer' &&
															column.cellRenderer !== 'viewRenderer' &&
															<div
																className="truncate overflow-hidden text-ellipsis whitespace-nowrap max-w-[200px]"
																title={dataValue?.length > 25 ? dataValue : ''}
															>
																{dataValue}
															</div>}
														{column.isDateValueFormat === true && (
															<p>
																{format(dataValue)}
															</p>
														)}
														{column.isCurrencyValueFormat === true && (
															<p >
																{currency(dataValue)}
															</p>
														)}
														{column.cellRenderer === 'viewRenderer' && (
															<ViewRendererComponent
																data={row}
																onEdit={onEdit}
															/>
														)}
														{column.cellRenderer === 'copyRenderer' && (
															<CopyRendererComponent data={row} />
														)}

														{column.isExecute &&
															<button
																type="button"
																className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
																onClick={() => handleRunScheduledTask(row)}
															>
																Run Now
															</button>}
														{column.input && (
															<InputContainer
																type={column.type}
																value={dataValue}
																onValueChange={(event: any) => handleInputChange(event, column.field, row)}

																className="w-full"
															/>
														)}
														{column.isUpdateTenantWebsite &&
															<button
																type="button"
																className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
																onClick={() => handleUpdateTenantWebsite(row)}
															>
																Update
															</button>}
														{column.cellRenderer === 'resetIconRenderer' && (
															<button
																className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
																onClick={() => handlereset(row)}> <FiRefreshCw />
															</button>
														)}
														{column.isEnableTenantWebsite &&
															<button
																type="button"
																className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
																onClick={() => handleEnableTenantWebsite(row)}
															>
																Enable
															</button>}

														{column.isAddressFormat === true &&
															<p className="text-sm font-light overflow-hidden text-ellipsis whitespace-nowrap max-w-[200px]" title={address}>
																{address}
															</p>
														}
														{column.cellRenderer === 'yesNoRenderer' && (
															<YesNoRendererComponent
																cellRenderer={column.cellRenderer}
																value={dataValue} />
														)}



														{column.cellRenderer === 'libraryRendererComponent' &&
															<LibraryRendererComponent
																cellRenderer={column.cellRenderer}
																cellRendererParams={column.cellRendererParams}
																data={column}
																dataId={row}
																onAgentAssignClick={onAgentAssignClick}
																onCargoDriverStatusClick={onCargoDriverStatusClick}
																onCargoDeliveryStatusClick={onCargoDeliveryStatusClick}
																onCargoTransitStatusClick={onCargoTransitStatusClick}
																onCargoIssueStatusClick={onCargoIssueStatusClick}
																onCargoPickupStatusClick={onCargoPickupStatusClick}
																onCargoOrderStatusClick={onCargoOrderStatusClick}
																onOrderStatusClick={onOrderStatusClick}
																onPaymentStatusClick={onPaymentStatusClick}
																onFullfillmentStatusSubmit={onFullfillmentStatusClick}
																onReturnRequestStatusClick={onReturnRequestStatusClick}
																onShippingStatusClick={onShippingStatusClick}
																value={dataValue}
															/>}
														{column.isExpanded &&

															<button
																aria-label="expand row"
																className="p-2 text-2xl"

																onClick={() => handleSubRowData(row)}
															>
																{isExpand ? <HiChevronUp /> : <HiChevronDown />}
															</button>}

													</td>

												</>
											)
										})}

										{onEdit || onDelete || IsRowUpdated ? <td key={9} className="flex p-5 w-max flex-row justify-center item-baseline cursor-pointer">
											<div className="flex items-center">
												{onEdit && <svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleEdit(row)} width="14" height="14" viewBox="0 0 24 24"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" /></svg>}
												{onDelete && <div className='pl-2'><svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleClickDelete(row)} width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>{modal}</div>}
												{IsRowUpdated &&
													<button className="text-black-500 hover:text-black-700" onClick={async () => handleSave(row)}>
														<FaSave className="w-3 h-3" />
													</button>}
												{IsPublishParticularVendorToCloud &&
													<PublishVendorToCloudContextMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleParticularOrgRegistry={handleParticularOrgRegistry} row={row} />
												}
												{/* Website Menu*/}
												{IsWebsites &&
													<Menu as="div" className="text-left relative">
														<div>
															<Menu.Button
																onClick={(e: any) => setAnchorShipmentEl(e.currentTarget)}
																className="pt-1 pl-1 text-gray-700 hover:text-gray-900 rounded cursor-pointer"
															>
																<svg
																	xmlns="http://www.w3.org/2000/svg"
																	fill="currentColor"
																	viewBox="0 0 24 24"
																	width="18"
																	height="18"
																>
																	<circle cx="12" cy="5" r="2" />
																	<circle cx="12" cy="12" r="2" />
																	<circle cx="12" cy="19" r="2" />
																</svg>
															</Menu.Button>
														</div>

														{anchorShipmentEl && (
															<Menu.Items className="absolute z-40 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 min-h-60 overflow-y-auto" style={{ left: '-200px' }} >
																<div className="px-1 py-1">
																	{/* CDN Related Actions Section */}
																	<div className="px-2 py-1 font-semibold text-gray-700 underline">CDN Related Actions</div>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handlePublishTenantWebsite(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black ${row.TableUrl === null && row.CDNEndpointUrl === null ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'
																					}`}
																				title="Publish tenant Websites in CDN"
																				disabled={!(row.TableUrl === null && row.CDNEndpointUrl === null)}
																			>
																				Publish in CDN
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleCDNUpdateWebsite(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
																				title="Add Newly updated Cards to the tenant websites already  published in CDN"
																			>
																				Update in CDN
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleCDNResetClick(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
																				title="To reset the websites already published in CDN"
																			>
																				Reset  websites in CDN
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleCDNDeleteClick(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
																				title="To delete  the tenant websites published in CDN"
																			>
																				Delete  websites in CDN
																			</button>
																		)}
																	</Menu.Item>

																	{/* Website Related Logic Section */}
																	<div className="px-2 py-1 font-semibold text-gray-700 underline">Websites Related Actions</div>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleSave(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
																				title="Update tenant websites details"
																			>
																				Update Tenant websites
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleUpdateTenantWebsite(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}

																				title='Add New Updated cards published in Platform Website'
																			>
																				Add New Cards to website
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleEnableTenantWebsite(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}

																				title='To activate Disabled website'
																			>
																				Enable to tenant Website
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleClickReset(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
																				title='Reset the current website and create new records  with Platform Website'
																			>
																				Reset Tenant Website
																			</button>
																		)}
																	</Menu.Item>
																</div>
															</Menu.Items>
														)}
													</Menu>}
											</div>

										</td> : null}
									</tr>
										<ExpandTableContainer
											subRowData={subRowData}
											isExpand={isExpand}
											subRowDataId={subRowDataId}
											subColumnDefs={subColumnDefs}
											row={row}
											columnData={columnData} /></>
								)
								)
								}
							</>
						</tbody>
					</table>
						:
						<div className='w-full text-start text-xl p-6 border-2 border-skin-ouprimary rounded-lg'>No Data in the page</div>}
				</div>



				{filteredData?.length !== 0 && paginationData ? <div className="flex items-center justify-center w-full gap-8 my-2">
					<PaginationContainer
						pages={paginationData}
						handleChangeRowsPerPage={setPageSize}
						handleFirstPageButtonClick={() => setPageData(1)}
						handleBackButtonClick={() => setPageData(paginationData?.PageNumber - 1)}
						handleNextButtonClick={() => setPageData(paginationData?.PageNumber + 1)}
						handleLastPageButtonClick={() => setPageData(paginationData?.TotalPages || 1)}
					/>
				</div> : ''}
			</div>
		</>


	)
}

export default Table